module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic2.5f16acd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic2.png
// module id = 568
// module chunks = 1